import http from "@/http/aisea/axios";
const resource = "/notification";

export default {
  fetchNotifications(payload) {
    return http.get(`${resource}`, { params: payload });
  },

  fetchNotification(notificationId) {
    return http.get(`${resource}/${notificationId}`);
  },

  unreadCount() {
    return http.get(`${resource}/unread`);
  },

  read(notificationId) {
    return http.put(`${resource}/${notificationId}/read`);
  }
};
